import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';

export const navigationItemAnimation = trigger('navigationItem', [
  state(
    'active',
    style({
      transform: 'scale(1.2)'
    })
  ),
  state(
    'inactive',
    style({
      transform: 'scale(1)'
    })
  ),
  transition('active <=> inactive', [animate('0.2s')])
]);
